import type { IdentifiedTopic } from "@/generated/fastapi";

export function sortIdentifiedTopicsByConfidence(
  topics: IdentifiedTopic[],
): IdentifiedTopic[] {
  return topics.sort((a, b) => {
    const confidenceA = a.confidence ?? 0;
    const confidenceB = b.confidence ?? 0;
    return confidenceB - confidenceA;
  });
}

export function stringifyIdentifiedTopic(topic: IdentifiedTopic): string {
  return `Aim: ${topic.aim}\nValues: ${topic.communicated_values?.join(
    ", ",
  )}\nConfidence: ${topic.confidence}\n\nTopic: ${topic.topic}\nHeadline: ${
    topic.headline
  }\nClaim: ${topic.claim}\nContent Outline:\n- ${topic.content_outline?.join(
    "\n- ",
  )}\n\nPrompting Questions:\n- ${topic.prompting_questions?.join("\n- ")}`;
}
